import { render } from "./App.vue?vue&type=template&id=10416388"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10416388&lang=css"
script.render = render

export default script